module.exports = __webpack_public_path__ + "img/product4.47d993e1.png";